import React, { useState } from "react";
import {
  Breadcrumb,
  Container,
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { getPendingHotels, getApprovalStatus } from "../../helpers/api.ts";
import Swal from "sweetalert2";

const Hotels = () => {
  const [hotels, setHotels] = useState([]);
  const [selectedHotel, setSelectedHotel] = useState(null);
  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  React.useEffect(() => {
    const fetchData = async () => {
      const response = await getPendingHotels();
      setHotels(response.data);
    };
    fetchData();
  }, []);

  const handleViewDetails = (hotel) => {
    setSelectedHotel(hotel);
    toggle();
  };

  const handleStatusChange = async (hotelId, status) => {
    try {
      Swal.fire({
        title: `Are you sure you want to ${status.toLowerCase()} this hotel?`,
        text: "This action cannot be undone!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: status === "Approved" ? "#28a745" : "#dc3545",
        cancelButtonColor: "#6c757d",
        confirmButtonText: `Yes, ${status.toLowerCase()} it!`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const response = await getApprovalStatus(hotelId, status);
          if (response.success) {
            const updatedHotels = await getPendingHotels();
            setHotels(updatedHotels.data);
            toggle();
            
            Swal.fire({
              title: "Success!",
              text: `Hotel has been ${status.toLowerCase()} successfully.`,
              icon: "success",
              confirmButtonColor: "#28a745",
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: "Something went wrong.",
              icon: "error",
              confirmButtonColor: "#dc3545",
            });
          }
        }
      });
    } catch (error) {
      console.error(`Error ${status} hotel:`, error);
      Swal.fire({
        title: "Error!",
        text: `Failed to ${status.toLowerCase()} hotel. Please try again.`,
        icon: "error",
        confirmButtonColor: "#dc3545",
      });
    }
  };

  return (
    <>
      <div className="page-content">
        <Container fluid={false}>
          <Breadcrumb title="Home" breadcrumbItem="Pending Hotels" />
        </Container>

        <div className="table-responsive">
        <Table>
          <thead>
            <tr>
              <th>#</th>
              <th>Hotel Name</th>
              <th className="d-none d-md-table-cell">Owner Name</th>
              <th>Total Rooms</th>
              <th className="d-none d-lg-table-cell">Address</th>
              <th className="d-none d-md-table-cell">Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {hotels.map((hotel, index) => (
              <tr key={index}>
                <th scope="row">{index + 1}</th>
                <td>
                  <div className="d-flex flex-column">
                    <span>{hotel.hotel_name}</span>
                    <small className="text-muted d-md-none">{hotel.owner.name}</small>
                  </div>
                </td>
                <td className="d-none d-md-table-cell">{hotel.owner.name}</td>
                <td>{hotel.total_rooms}</td>
                <td className="d-none d-lg-table-cell">{hotel.address}</td>
                <td className="d-none d-md-table-cell">{hotel.status}</td>
                <td>
                  <Button
                    color="info"
                    size="sm"
                    onClick={() => handleViewDetails(hotel)}
                    className="w-100 w-sm-auto"
                  >
                    View Details
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        </div>

        <Modal isOpen={modal} toggle={toggle} size="lg" className="modal-fullscreen-md-down">
          <ModalHeader toggle={toggle}>Hotel Details</ModalHeader>
          <ModalBody>
            {selectedHotel && (
              <div>
                <h5>Hotel Information</h5>
                <p>
                  <strong>Name:</strong> {selectedHotel.hotel_name}
                </p>
                <p>
                  <strong>Address:</strong> {selectedHotel.address}
                </p>
                <p>
                  <strong>Total Rooms:</strong> {selectedHotel.total_rooms}
                </p>
                <p>
                <strong>GST Number:</strong> {selectedHotel.gst_number}
                </p>
                <p>
                  <strong>GST Percentage:</strong> {selectedHotel.gst_percentage}
                </p>

                <h5 className="mt-4">Owner Information</h5>
                <p>
                  <strong>Name:</strong> {selectedHotel.owner.name}
                </p>
                <p>
                  <strong>Email:</strong> {selectedHotel.owner.email}
                </p>

                <h5 className="mt-4">Status</h5>
                <p>
                  <strong>Current Status:</strong> {selectedHotel.status}
                </p>
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              color="success"
              onClick={() => handleStatusChange(selectedHotel.hotel_id, "Approved")}
            >
              Approve Hotel
            </Button>
            <Button
              color="danger"
              onClick={() => handleStatusChange(selectedHotel.hotel_id, "Rejected")}
            >
              Reject Hotel
            </Button>
            <Button color="secondary" onClick={toggle}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </>
  );
};

export default Hotels;